module.exports = __webpack_public_path__ + "static/biglietteria.d4482cc2.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/assets/images/biglietteria.jpg
// module id = 193
// module chunks = 27896102843358 35783957827783